export interface jobSupportProjectParticipant {
  id: number
  jobPostingId: number
  method?: string
  userId: number
  isDone?: boolean
  createdAt: string
  updatedAt: string
}

export interface publicJobSupportProjectParticipant {
  method: string
  status: string
}

export enum JobSupportProjectParticipantMethod {
  SMS = 'sms',
  FAX = 'fax',
  FILE = 'file',
}

export const JobSupportProjectParticipantMethodLabel = {
  [JobSupportProjectParticipantMethod.SMS]: '문자',
  [JobSupportProjectParticipantMethod.FAX]: '팩스',
  [JobSupportProjectParticipantMethod.FILE]: '파일',
}
